import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { TraderDetailsModalTrigger } from '@fiverr-private/trader_details';
import { Link } from '@fiverr-private/typography';

interface RolePageFreelancerDetailsProps {
    sellerId: string;
    sellerName: string;
}

export const RolePageFreelancerDetails = ({ sellerId, sellerName }: RolePageFreelancerDetailsProps) => (
    <TraderDetailsModalTrigger sellerId={sellerId} sellerName={sellerName} showCaptcha>
        <Link cursor="pointer">
            <I18n k="seller_page_perseus.professions_page.freelancer_details" />
        </Link>
    </TraderDetailsModalTrigger>
);
